export const TEMP_PREFIX = 'temp-';

export const isTempId = (id) => {
  return typeof id === 'string' && id.startsWith(TEMP_PREFIX);
};

export const makeTempId = (prefix = TEMP_PREFIX) => {
  return `${prefix}${Date.now()}`;
};


